import { AngularDeviceInformationService } from 'angular-device-information';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Cliente } from 'src/app/interface/cliente';
import { CabecalhoRomaneioCliente, RomaneioClienteDto, RomaneioInfCertificado, defaultCabecalhoRomaneioCliente, defaultRomaneioClienteDto, defaultRomaneioInfCertificado } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { FiltroRomaneioClienteLista } from '../filter/filtro-romaneio-cliente-lista';
import { PedidoService } from 'src/app/faturamento/service/pedido.service';
import { FiltroPedidoCliente, getFiltroPedidoClienteDefault } from 'src/app/faturamento/interface/pedido';
import { AuthService } from 'src/app/service/auth.service';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { Transportadora } from 'src/app/interface/transportadora';
import { Veiculo } from '../../romaneio/interface/veiculo';
import { VeiculoLookupService } from '../../romaneio/service/veiculo-lookup-service';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { NgForm } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-romaneio-cliente-lista-expedicao',
  templateUrl: './romaneio-cliente-lista-expedicao.component.html',
  styleUrls: ['./romaneio-cliente-lista-expedicao.component.css']
})
export class RomaneioClienteListaExpedicaoComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRomaneioClienteLista;

  novoCadastroRomaneio: CabecalhoRomaneioCliente;

  alteraRomaneio: RomaneioClienteDto;
  dadosInfCertificado: RomaneioInfCertificado = defaultRomaneioInfCertificado();

  tabelaUrItens: Array<any> = [];

  permissaoExcluir: boolean = false;
  bloqueiaPlaca: boolean = false;

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  varStatus: Array<PoSelectOption>;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  filtroPedidoCliente: FiltroPedidoCliente = getFiltroPedidoClienteDefault();

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private pedidoService: PedidoService,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    public clienteLookupService: ClienteLookupService,
    public veiculoLookupService: VeiculoLookupService,
    public transportadoraService: TransportadoraService,
    private authService: AuthService,
  ) {

    this.tabelaPrincipalFiltro = new FiltroRomaneioClienteLista(this.poStorageService);

    this.novoCadastroRomaneio = defaultCabecalhoRomaneioCliente();
    this.alteraRomaneio = defaultRomaneioClienteDto();

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;


    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

    this.varStatus = this.listaStatus();

  }

  @ViewChild('modalValidaSenha'     , { static: true }) modalValidaSenha!: PoModalComponent;
  @ViewChild('advancedFilterModal'  , { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('criarRomaneioModal'   , { static: true }) criarRomaneioModal!: PoModalComponent;
  @ViewChild('editarDadosEtapaModal', { static: true }) editarDadosEtapaModal!: PoModalComponent;
  @ViewChild('modalInfCertificado'  , { static: true }) modalInfCertificado!: PoModalComponent;
  @ViewChild('formValidaSenha'      , { static: true }) formValidaSenha!: NgForm;
  @ViewChild('formInfCertificado'   , { static: true }) formInfCertificado!: NgForm;

  ngOnInit(): void {
    this.authService.validaPrivilegio(["PO_EXPEDICAO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
      this.permissaoExcluir = !ret;
    });


    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.listaRomaneioCliente(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ00COD'   , label: 'Código'          , width: '6%'},
    {property: 'DZ00DATA'  , label: 'Data'            , width: '7%' , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ00CLIENT', label: 'Cliente'         , width: '6%'},
    {property: 'CA1NOME'   , label: 'Nome Cliente'    , width: '15%'},
    {property: 'CZ00STATUS', label: 'Status'          , width: '10%', type: 'label',
      labels: [
        { value: '0', color: 'color-01',  label: 'Disp. Romaneio'   },
        { value: '1', color: 'color-08',  label: 'Lib. Comercial'   },
        { value: '2', color: 'color-11',  label: 'Pendente NFs'        },
        { value: '3', color: 'color-07',  label: 'Fat. sem Dados'   },
        { value: '4', color: 'color-09',  label: 'A Carregar'       },
        { value: '5', color: 'color-10',  label: 'Carregamento Autorizado' },
        { value: '6', color: 'color-10',  label: 'Carregado'        },
        { value: 'Z', color: 'color-05',  label: 'Finalizado'       },
      ]
    },
    {property: 'CZ00HORA'  , label: 'Hora'            , width: '6%'},
    {property: 'CEE7PEDIDO', label: 'Ped Cliente'     , width: '8%'},
    {property: 'CEE7PEDFAT', label: 'Ped Fat.'        , width: '7%'},
    {property: 'NEE7PESOLI', label: 'Peso Lim.'       , width: '7%' , type: 'number', format: '1.2-2'},
    {property: 'NPESOTOT'  , label: 'Peso Acum.'      , width: '7%' , type: 'number', format: '1.2-2'},
    {property: 'DZ00DTLIB' , label: 'Dt. Liberação'   , width: '6%' , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ00HRLIB' , label: 'Hr. Liberação'   , width: '6%'},
    {property: 'CEE9PREEMB', label: 'Nº. Processo'    , width: '6%'},
  ];

  public readonly tabelaPrincipalAction: Array<PoTableAction> = [
    {
      action: this.editar.bind(this),
      icon: 'po-icon-edit',
      label: 'Editar',
      disabled: this.desabilitaEditar.bind(this)
    },
    {
      action: this.getPDFRomaneio.bind(this),
      icon: 'po-icon-credit-payment',
      label: 'Etiqueta Cliente'
    },
    {
      action: this.editarDadosEtapa.bind(this),
      icon: 'po-icon-clipboard',
      label: 'Editar Dados Etapa',
      disabled: this.desabilitaEditarDadosEtapa.bind(this)
    },
    {
      action: this.openDialogConfirmarExcluirRomaneio.bind(this),
      icon: 'po-icon-delete',
      label: 'Excluir',
      disabled: this.desabilitaExcluir.bind(this)
    },
    {
      action: this.retornarPendente.bind(this),
      icon: 'po-icon-change',
      label: 'Retorna p/ Pendente',
      disabled: this.desabilitaRetornarPendente.bind(this)
    },
    {
      action: this.modalPDFRomaneio.bind(this),
      icon: 'po-icon-mail',
      label: 'Envia PDF',
      disabled: this.desabilitaEnvioPDF.bind(this)
    },
    {
      action: this.openModalInfCertificado.bind(this),
      icon: 'po-icon-info',
      label: 'Inf. Certificado',
      disabled: this.desabilitaInfCertificado.bind(this)
    },
  ]

  public readonly tabelaUrColumns: Array<PoTableColumn> = [
    { property: 'UR', label: 'Código UR', width: '100%' },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Criação Romaneio', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  public readonly criarRomaneioAction: PoModalAction = {
    action: () => {
      this.criarRomaneioModal.close();
      this.novoRomaneio();
    },
    label: 'Confirmar'
  };

  public readonly optionsTratamento: Array<PoSelectOption> = [
    {value: '1', label: 'KD - Secagem Estufa'},
    {value: '2', label: 'HT - Tratamento Térmico'},
  ]

  public readonly optionsTecnico: Array<PoSelectOption> = [
    {value: '1', label: '01 - Mauro Murara'},
    {value: '2', label: '02 - Ronald'},
  ]

  openModalNovoRomaneio(): void {
    this.criarRomaneioModal.open();
  }

  novoRomaneio(): void {
    this.romaneioService.criarRomaneioCliente(this.novoCadastroRomaneio).subscribe((ret) => {
      this.router.navigateByUrl(`/estoque/expedicao/romaneio-cliente/cadastro/${ret.CZ00COD}`);
    });
  }

  desabilitaEditar(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS  == 'Z';
  }

  desabilitaEditarDadosEtapa(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS  == '3';
  }

  desabilitaExcluir(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS == 'Z' || this.permissaoExcluir;
  }

  desabilitaRetornarPendente(row: CabecalhoRomaneioCliente): boolean {
    return (this.permissaoExcluir || row.CZ00STATUS == '0');
  }

  desabilitaEnvioPDF(row: CabecalhoRomaneioCliente): boolean {
    return (row.CZ00STATUS !== 'Z');
  }

  desabilitaInfCertificado(row: CabecalhoRomaneioCliente): boolean {
    return (row.CZ00STATUS === '0');
  }

  editar(row: CabecalhoRomaneioCliente): void {
    this.router.navigateByUrl(`/estoque/expedicao/romaneio-cliente/cadastro/${row.CZ00COD}`);
  }

  editarDadosEtapa(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getRomaneioClienteShort(row.CZ00COD).subscribe(romaneio => {
      this.alteraRomaneio = romaneio;
      if ((this.alteraRomaneio.CZ00STATUS === '3' || this.alteraRomaneio.CZ00STATUS === '4') ) {
        this.bloqueiaPlaca = true;
      } else {
        this.bloqueiaPlaca = false;
      }
      this.editarDadosEtapaModal.open();
    });
  }

  getPDFRomaneio(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getPdfRomaneio(row.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${row.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  openDialogConfirmarExcluirRomaneio(row: CabecalhoRomaneioCliente): void {
    this.poDialogService.confirm({
      title: 'Excluir Romaneio',
      message: 'Deseja realmente excluir o romaneio?',
      confirm: () => this.excluirRecebimentoMercadoria(row)
    });
  }


  excluirRecebimentoMercadoria(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.excluirRomaneio(row.CZ00COD).subscribe( () => {
      this.tabelaPrincipalLoad();
    });
  }

  retornarPendente(row: CabecalhoRomaneioCliente): void {
    this.poDialogService.confirm({
      title: 'Retornar para Pendente',
      message: 'Deseja realmente voltar esse romaneio para PENDENTE?',
      confirm: () => this.retornarRomaneioPendente(row)
    });
  }

  retornarRomaneioPendente(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.retornarPendente(row.CZ00COD).subscribe( (ret) => {
      if (ret.lSuccess) {
        this.tabelaPrincipalLoad();
      } else {
        if (ret.cTipoErro == "H") {
          this.poDialogService.confirm({
            title: 'Passou do prazo',
            message: 'A nota fiscal já foi gerada, porém não é mais possível realizar o cancelamento devido ao prazo de 24h. Deseja estornar o romaneio mesmo assim?',
            confirm: () => this.forcarRetornarRomaneioPendente(row)
          });
        }
      }
    });
  }

  forcarRetornarRomaneioPendente(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.forcaRetornarPendente(row.CZ00COD).subscribe( (ret) => {
      this.poNotificationService.success("Romaneio estornado com sucesso!");
      this.tabelaPrincipalLoad();
    });
  }

  clienteSelecionado(row: Cliente): void {
    this.novoCadastroRomaneio.CZ00CLIENT = row.CA1COD;
    this.novoCadastroRomaneio.CZ00LOJA = row.CA1LOJA;
  }

  listaStatus(): Array<PoSelectOption> {
    return [
      { value: "0", label: "Pendente Expedição" },
      { value: "1", label: "Pendente Comercial" },
      { value: "2", label: "A Faturar"          },
      { value: "3", label: "Faturado sem Dados" },
      { value: "Z", label: "Finalizado"         },
      { value: "T", label: "Todos"              },
    ];
  }

  getClientePedido(): void {
    this.pedidoService.getClientePedido(this.filtroPedidoCliente).subscribe((ret) => {
      this.novoCadastroRomaneio.CZ00CLIENT = ret.CC5CLIENTE+ret.CC5LOJACLI;
    });

    this.filtroPedidoCliente = getFiltroPedidoClienteDefault();
  }

  openModalInfCertificado(row: CabecalhoRomaneioCliente): void {
    this.dadosInfCertificado = defaultRomaneioInfCertificado();
    this.dadosInfCertificado.CZ00COD    = row.CZ00COD;
    this.dadosInfCertificado.CZ00NCERT  = row.CZ00NCERT;
    this.dadosInfCertificado.NQTDZ02UR  = row.NQTDZ02UR;
    this.tabelaUrItens = row.AURS.map((item) => {
      return {...item};
    });

    this.modalInfCertificado.open()
  }

  closeModalInfCertificado(): void {
    this.dadosInfCertificado = defaultRomaneioInfCertificado();
    this.tabelaUrItens = [];
    this.modalInfCertificado.close()
  }

  gravarModalInfCertificado(): void {
    if (!this.dadosInfCertificado.CZ02UR || !this.dadosInfCertificado.CZ00NCERT){
      this.poNotificationService.warning("Código UR ou N° Certificado não identificado.")
    } else{
      this.romaneioService.postInformacaoCertificadoRomaneio(this.dadosInfCertificado).subscribe({
        next: () => {
          this.closeModalInfCertificado();
          this.tabelaPrincipalLoad();
          this.poNotificationService.success("Informações gravadas com sucesso!")
        }
      })
    }
  }

  certificadosModalInfCertificado(): void {
    this.poDialogService.confirm({
      title: 'Gerar Certificado',
      message: 'Esta ação irá fazer o download do certificado de todas as URs. Deseja prosseguir?',
      confirm: () => this.baixarPDFCertificados()
    });
  }

  async baixarPDFCertificados() {
    var retBlob;

    for (var qtdUR = 1; qtdUR <= this.dadosInfCertificado.NQTDZ02UR; qtdUR++){
      retBlob = (await firstValueFrom(this.romaneioService.getPdfCertificados(this.dadosInfCertificado.CZ00COD,qtdUR)))

      var file = new Blob([retBlob], {type: 'application/pdf'});
      var fileName = `Certificado_${new Date().toLocaleString().replace(/:/g,"").replace("/","").replace("/","").replace(", ","_")}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    };

    this.closeModalInfCertificado()
  }

  URSelecionada(dados: RomaneioInfCertificado): void {
    this.dadosInfCertificado.CZ02UR   = dados.$selected?dados.UR:"";
    this.dadosInfCertificado.CZEXTKD  = dados.$selected?dados.CZEXTKD:"";
    this.dadosInfCertificado.CZEXTEC  = dados.$selected?dados.CZEXTEC:"";
    this.dadosInfCertificado.CZEXINF  = dados.$selected?dados.CZEXINF:"";

    if(this.dadosInfCertificado.CZEXTKD === ""){
      this.dadosInfCertificado.CZEXTKD = "2"
    }
    if(this.dadosInfCertificado.CZEXTEC === ""){
      this.dadosInfCertificado.CZEXTEC = "1"
    }
  }

  modalPDFRomaneio(row: CabecalhoRomaneioCliente): void {
    this.poDialogService.confirm({
      title: 'Enviar PDF',
      message: 'Deseja enviar E-mail com o PDF do Romaneio e a Danfe da Nota para a transportadora?',
      confirm:()=> this.enviarPDFRomaneio(row.CZ00COD)
    });
  }

  enviarPDFRomaneio(CZ00COD: string): void {
    this.romaneioService.postEnviaPDFRomaneioTransportadora(CZ00COD).subscribe((ret)=>{
      this.poNotificationService.success("E-mail enviado com sucesso!");
    })
  };

  public readonly salvarDadosRomaneio: PoModalAction = {
    action: () => {
      this.romaneioService.alterarDadosRomaneioCliente(this.alteraRomaneio).subscribe((ret) => {
        this.editarDadosEtapaModal.close();
      })
    },
    label: 'Salvar',
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
